import { festivalDayKey } from './festival-time.ts'

type FactEvent = {
	date: Date | string
	location?: string | null
	host?: string | null
}

/** Where a concert happens: the location, or the host when no address is set. */
export const venueKey = (event: FactEvent) =>
	(event.location?.trim() || event.host?.trim() || '').toLowerCase()

/**
 * Headline numbers for a festival program. Not every event is a concert
 * (2026's Kunstkaffi is an art exhibition) and some are in the daytime, so
 * they are counted as events over festival days, not concerts over evenings.
 */
export function getProgramFacts(events: FactEvent[]) {
	const venues = new Set(events.map(venueKey).filter(Boolean))
	const days = new Set(events.map((event) => festivalDayKey(event.date)))
	return {
		events: events.length,
		venues: venues.size,
		days: days.size,
	}
}

const NUMBER_WORDS = [
	'null',
	'éin',
	'to',
	'tre',
	'fire',
	'fem',
	'seks',
	'sju',
	'åtte',
	'ni',
	'ti',
]

/** `one` is "eitt" for a neuter noun: "eitt arrangement" */
const count = (n: number, singular: string, plural: string, one = 'éin') =>
	n === 1 ? `${one} ${singular}` : `${NUMBER_WORDS[n] ?? n} ${plural}`

/** "Tre dagar, fem arrangement" — or "Programmet kjem" before there is one. */
export function formatProgramHeadline(events: FactEvent[]) {
	if (!events.length) return 'Programmet kjem'
	const facts = getProgramFacts(events)
	const text = `${count(facts.days, 'dag', 'dagar')}, ${count(facts.events, 'arrangement', 'arrangement', 'eitt')}`
	return text.charAt(0).toUpperCase() + text.slice(1)
}
